import { ServerErrorFragment } from "@saleor/fragments/types/ServerErrorFragment";
import { commonMessages } from "@saleor/intl";
import { ServerErrorCode } from "@saleor/types/globalTypes";
import { IntlShape } from "react-intl";

import commonErrorMessages from "./common";

function getPayoutMessage(
  err: Omit<ServerErrorFragment, "__typename"> | undefined,
  intl: IntlShape
): string {
  if (err) {
    switch (err.code) {
      case ServerErrorCode.GRAPHQL_ERROR:
        return intl.formatMessage(commonErrorMessages.graphqlError);
      case ServerErrorCode.REQUIRED:
        return intl.formatMessage(commonMessages.requiredField);
      case ServerErrorCode.INVALID:
        return intl.formatMessage(commonErrorMessages.invalid);
      default:
        return intl.formatMessage(commonErrorMessages.unknownError);
    }
  }

  return undefined;
}

export default getPayoutMessage;
